/**
 * Firebase Configuration - TypeScript Migration
 */

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import '@firebase/messaging';

// Initialize Firebase
firebase.initializeApp({
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_WEB_APP_ID,
});

export const firestore = firebase.firestore();
export const storage = firebase.storage();

// Messaging setup with browser support check
let messaging: firebase.messaging.Messaging | undefined;

if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging();
}

export { messaging };

/**
 * Requests permission for Firebase notifications and returns token
 */
export const requestFirebaseNotificationPermission = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!messaging) {
      reject(new Error('Messaging not supported in this browser'));
      return;
    }

    messaging
      .requestPermission()
      .then(() => messaging!.getToken())
      .then((firebaseToken) => {
        resolve(firebaseToken);
      })
      .catch((err) => {
        console.error('Notification permission error:', err);
        reject(err);
      });
  });
};

/**
 * Listens for incoming messages
 */
export const onMessageListener = (): Promise<any> => {
  return new Promise((resolve) => {
    if (!messaging) {
      resolve(null);
      return;
    }

    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });
};

/**
 * Service Worker registration for push notifications
 */
if ('serviceWorker' in navigator && messaging) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js',
        {
          updateViaCache: 'none',
        }
      );

      messaging!.useServiceWorker(registration);

      messaging!.onMessage((payload) => {
        const title = payload.notification?.title || 'Notification';
        const options: NotificationOptions = {
          body: payload.notification?.body,
          icon: payload.notification?.icon,
          data: {
            url: payload.fcmOptions?.link,
          },
        };

        registration.showNotification(title, options);
      });
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  });
}
